import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import subfolderIcon from "../../assets/subfolder.svg";
import versionIcon from "../../assets/versionIconRound.svg";
import arrowDown from "../../assets/arrowDown.svg";
import { ReactComponent as StarIcon } from "../../assets/starIconPurple.svg";
import {
  userSelector,
  currentOrganizationSelector,
  currentOrganizationOwnerSelector,
  organizationsListSelector,
  orgTariffesSelector,
} from "../../store/selectors";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "./TeamScreen.css";
import verticalDots from "../../assets/verticalDots.svg";
import { ReactComponent as MenuIcon } from "../../assets/mobile/menu.svg";
import ProfileSidebar from "../../components/ProfileSidebar/ProfileSidebar";
import AppLogo from "../../assets/AppLogoBlue.svg";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import {
  deleteUserFromOrganization,
  fetchUsers,
  inviteUserToOrganization,
} from "../../store/usersSlice";
import { userRoles } from "../../helpers/constants";
import {
  fetchProjectByIdForAccess,
  fetchProjects,
  fetchProjectsForAccess,
  fetchProjectUsers,
  fetchSubprojectsForProject,
  removeUserFromProject,
} from "../../store/projectsSlice";
import { OrbitProgress } from "react-loading-indicators";
import EmojiContextMenu from "../../components/CommentsBlock/EmojiContextMenu";
import UserRoleContextMenu from "../../components/CommentsBlock/UserRoleContextMenu";
import AccessPopup from "../../components/VideoPage/AccessPopup";
import useIsMobile from "../../hooks/useIsMobile";
import { setIsAppLoading } from "../../store/appSlice";
import UsersPopup from "../../components/VideoPage/UsersPopup";
import OrgUsersPopup from "../../components/VideoPage/OrgUsersPopup";

const TeamScreen = () => {
  const user = useSelector(userSelector);
  const currentOrganization = useSelector(currentOrganizationSelector);
  const currentOrganizationOwner = useSelector(
    currentOrganizationOwnerSelector
  );
  const orgsList = useSelector(organizationsListSelector);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [projectRolesLevels, setProjectRolesLevels] = useState([]);
  const [usersPopupEntity, setUsersPopupEntity] = useState(null);
  const [projectsStructure, setProjectsStructure] = useState({});
  const [accessPopupUser, setAccessPopupUser] = useState(null);
  const [rootProjectsData, setRootProjectsData] = useState([]);
  const [workspaceLoading, setWorkspaceLoading] = useState(false);
  const [newMemberRole, setNewMemberRole] = useState("EDITOR");
  const [usersArray, setUsersArray] = useState([]);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [newMemberEmail, setNewMemberEmail] = useState("");
  const [uniqueEmails, setUniqueEmails] = useState();
  const [activeTab, setActiveTab] = useState("");
  const [menuUser, setMenuUser] = useState(null);
  const [orgToShowUsersPopup, setOrgToShowUsersPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const organizationsTariffes = useSelector(orgTariffesSelector);
  const userName = user?.email;
  const contextMenuRef = useRef();
  const [contextMenuPosition, setContextMenuPosition] = useState({
    top: 0,
    left: 0,
  });
  const [activeRole, setActiveRole] = useState(null);
  const filteredOrgsList = orgsList.filter((org) => {
    if (!user || !user.organizationRoles) return false;
    const myRole = user.organizationRoles.find(
      (role) => role.organizationId === org.id
    );
    if (!myRole || myRole.role !== "OWNER") return false;
    return true;
  });

  const modalStyles = {
    inviteRow: {
      display: "flex",
      alignItems: "stretch",
      width: isMobile ? "100%" : "60%",
      marginBottom: isMobile ? 0 : "20px",
      marginTop: isMobile ? "10px" : 0,
    },
    inviteInputWrap: {
      display: "flex",
      flex: 1,
      border: "1px solid #333b4b",
      borderRadius: "80px",
      overflow: "hidden",
    },
    inviteInput: {
      flex: 1,
      height: "auto",
      padding: "12px 16px",
      borderTopLeftRadius: "80px",
      borderBottomLeftRadius: "80px",
      backgroundColor: "transparent",
      border: "none",
      color: "#F1F7FF",
      fontSize: "14px",
      fontWeight: 500,
    },
    inviteDivider: {
      width: "1px",
      backgroundColor: "#333b4b",
      margin: "12px 0",
    },
    inviteSelect: {
      padding: "12px 16px",
      backgroundColor: "transparent",
      border: "none",
      color: "#717b8e",
      fontSize: "14px",
      fontWeight: 500,
      cursor: "pointer",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6L8 10L12 6' stroke='%23717b8e' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      textAlign: "right",
      paddingRight: "36px",
      WebkitTapHighlightColor: "transparent",
      WebkitTouchCallout: "none",
      WebkitUserSelect: "none",
      MozUserSelect: "none",
      msUserSelect: "none",
      userSelect: "none",
      outline: "none",
      textAlign: "right",
    },
    inviteBtn: {
      marginLeft: "8px",
      padding: "12px 24px",
      backgroundColor: "#e8f2ff",
      borderRadius: "80px",
      border: "none",
      color: "#1f242e",
      fontSize: "14px",
      fontWeight: 500,
      cursor: "pointer",
      whiteSpace: "nowrap",
    },
    inviteBtnDisabled: {
      marginLeft: "8px",
      padding: "12px 24px",
      backgroundColor: "#4a4f5c",
      borderRadius: "80px",
      border: "none",
      color: "#717b8e",
      fontSize: "14px",
      fontWeight: 500,
      cursor: "default",
      whiteSpace: "nowrap",
    },
    memberList: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      maxHeight: "300px",
      overflowY: "auto",
      overflowX: "hidden",
      width: "100%",
      marginTop: "8px",
      scrollbarWidth: "none" /* Firefox */,
      msOverflowStyle: "none" /* IE and Edge */,
      "&::-webkit-scrollbar": {
        /* Chrome, Safari and Opera */ display: "none",
      },
    },
    memberRow: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      padding: "8px",
      borderRadius: "8px",
      boxSizing: "border-box",
      width: "60%",
      paddingLeft: 20,
      background: "#232733",
      minHeight: "53.5px",
      marginBottom: 20,
    },
    avatar: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      flexShrink: 0,
    },
    email: {
      flex: 1,
      color: "#c1c4cb",
      fontSize: "16px",
      fontWeight: 500,
      textAlign: "left",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    select: {
      padding: "8px 0 8px 16px",
      backgroundColor: "transparent",
      border: "none",
      color: "#717b8e",
      marginBottom: 3,
      fontSize: "14px",
      fontWeight: 500,
    },
    selectOwner: {
      color: "#c1c4cb",
      cursor: "default",
      backgroundImage: "none",
    },
    rowInviteButton: {
      padding: "8px 24px",
      backgroundColor: "white",
      borderRadius: 80,
      fontSize: 14,
      cursor: "pointer",
    },
  };

  useEffect(() => {
    document.title = "7cut • Команда и доступы";
    const handleKeyDown = (event) => {
      if (
        contextMenuRef.current &&
        !contextMenuRef.current.contains(event.target)
      ) {
        setMenuAnchor(null);
        setMenuUser(null);
      }
    };
    window.addEventListener("mousedown", handleKeyDown);
    return () => window.removeEventListener("mousedown", handleKeyDown);
  }, []);

  useEffect(() => {
    setActiveTab(currentOrganization.title);
  }, [currentOrganization]);

  useEffect(() => {
    const org = orgsList.find((item) => item.title === activeTab);
    if (org) {
      updateAllData(org.id);
    }
  }, [activeTab]);

  const validateEmail = (email) => {
    return email.match("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$");
  };

  const updateAllData = async (orgId) => {
    setWorkspaceLoading(true);
    setIsLoading(true);
    setProjectRolesLevels([]);
    updateUsersArray(orgId);
  };

  const updateUsersArray = async (orgId) => {
    const newProjectsStructure = {};
    const organizationId = orgId || currentOrganization.id;
    const rootUsersRes = await dispatch(fetchUsers(organizationId));
    if (rootUsersRes.error) {
      setWorkspaceLoading(false);
      setIsLoading(false);
      return;
    }
    const orgUsersArray = rootUsersRes.payload.map((roleInfo) => ({
      ...roleInfo.user,
      role: roleInfo.role,
    }));
    const orgUsersIds = orgUsersArray.map((usr) => usr.id);
    const rootProjectsRes = await dispatch(
      fetchProjectsForAccess({ organizationId })
    );
    if (rootProjectsRes.error) {
      setIsLoading(false);
      setWorkspaceLoading(false);
      return;
    }
    const rootProjectsChildren = {};
    for (let i = 0; i < rootProjectsRes.payload.length; i++) {
      const rootProj = rootProjectsRes.payload[i];
      const projectRolesRes = await dispatch(fetchProjectUsers(rootProj.id));
      const rolesArray =
        (!projectRolesRes.error && projectRolesRes.payload) || [];
      rootProjectsChildren[rootProj.id] = {
        id: rootProj.id,
        title: rootProj.title,
        isOrg: false,
        isFolder: true,
        isUnfolded: true,
        isVersion: false,
        children: {},
        users: rolesArray.filter(
          (usr) =>
            !usr.allowedContentVersionIds.length &&
            !orgUsersIds.includes(usr.userId) &&
            usr.status === "ACTIVE"
        ),
      };
    }
    const rootEntity = {
      [organizationId]: {
        id: organizationId,
        title: activeTab,
        isOrg: true,
        isFolder: false,
        isVersion: false,
        children: {
          ...rootProjectsChildren,
        },
        users: orgUsersArray,
      },
    };
    setProjectsStructure(rootEntity);
    setWorkspaceLoading(false);
    updateChildEntities(
      rootEntity,
      rootProjectsChildren,
      organizationId,
      orgUsersIds
    );
  };

  const updateChildEntities = async (
    currentRootEntity,
    currentRootProjects,
    orgId,
    orgUsersIds
  ) => {
    const newRootProjects = {
      ...currentRootProjects,
    };
    for (let i = 0; i < Object.keys(currentRootProjects).length; i++) {
      const projectId = Object.keys(currentRootProjects)[i];
      const branch = await getProjectChildren(projectId, orgUsersIds);
      const { children: branchChildren, users } = branch;
      newRootProjects[projectId].children = {
        ...branchChildren,
        ...newRootProjects[projectId].children,
      };
    }

    const newRootEntity = {
      ...currentRootEntity,
      [orgId]: {
        ...currentRootEntity[orgId],
        children: newRootProjects,
      },
    };
    setIsLoading(false);
    setProjectsStructure(newRootEntity);
  };

  const getProjectChildren = async (
    projectId,
    orgUsersIds,
    omitUsersArray = []
  ) => {
    const result = {};
    const projectRes = await dispatch(fetchProjectByIdForAccess({ projectId }));
    if (projectRes.error) return result;
    const projectUsersRes = await dispatch(fetchProjectUsers(projectId));
    const usersArray =
      (!projectUsersRes.error &&
        projectUsersRes.payload &&
        projectUsersRes.payload.filter(
          (usr) => !!usr.userId && !omitUsersArray.includes(usr.userId)
        )) ||
      [];
    const projUsersIds = usersArray.map((usr) => usr.userId);
    const fetchedProject = projectRes.payload;
    for (let i = 0; i < fetchedProject.versions.length; i++) {
      const versionUsers = usersArray.filter(
        (usr) =>
          usr.allowedContentVersionIds.includes(
            fetchedProject.versions[i].id
          ) &&
          usr.status === "ACTIVE" &&
          !omitUsersArray.includes(usr.userId) &&
          !!usr.userId
      );
      result[fetchedProject.versions[i].id] = {
        id: fetchedProject.versions[i].id,
        title: fetchedProject.versions[i].version,
        isFolder: false,
        isVersion: true,
        parentId: +projectId,
        users: versionUsers,
      };
    }
    for (let i = 0; i < fetchedProject.subprojects.length; i++) {
      const fetchedSubprojectBranch = await getProjectChildren(
        fetchedProject.subprojects[i].id,
        orgUsersIds,
        [...omitUsersArray, ...projUsersIds]
      );
      const { children: branchChildren, users } = fetchedSubprojectBranch;
      result[fetchedProject.subprojects[i].id] = {
        id: fetchedProject.subprojects[i].id,
        title: fetchedProject.subprojects[i].title,
        isFolder: true,
        isVersion: false,
        parentId: +projectId,
        children: {
          ...branchChildren,
        },
        users: users.filter(
          (usr) =>
            !usr.allowedContentVersionIds.length &&
            !orgUsersIds.includes(usr.userId) &&
            !omitUsersArray.includes(usr.userId) &&
            !!usr.userId
        ),
      };
    }
    return {
      children: result,
      users: usersArray,
    };
  };

  // const updateUsersArray = async (orgId) => {
  //   await dispatch(fetchUsers(orgId || currentOrganization.id)).then((res) => {
  //     if (!res.error) {
  //       const orgUsersArray = res.payload.map((roleInfo) => ({
  //         ...roleInfo.user,
  //         role: roleInfo.role,
  //       }));
  //       let newUniqueEmails = {};
  //       for (let i = 0; i < orgUsersArray.length; i++) {
  //         if (newUniqueEmails[orgUsersArray[i].email]) {
  //           newUniqueEmails[orgUsersArray[i].email] =
  //             newUniqueEmails[orgUsersArray[i].email] + 1;
  //         } else {
  //           newUniqueEmails[orgUsersArray[i].email] = 1;
  //         }
  //       }
  //       setUniqueEmails(newUniqueEmails);
  //       const newProjectRolesLevels = [
  //         [
  //           {
  //             title: currentOrganization.title,
  //             isOrg: true,
  //             id: orgId || currentOrganization.id,
  //             roles: orgUsersArray,
  //           },
  //         ],
  //       ];
  //       setProjectRolesLevels(newProjectRolesLevels);
  //       updateRootProjectsData(orgId, newProjectRolesLevels, newUniqueEmails);
  //     }
  //     return [];
  //   });
  // };

  // const updateRootProjectsData = (
  //   orgId,
  //   currentProjectsRolesLevels,
  //   currentUniqueEmails
  // ) => {
  //   dispatch(
  //     fetchProjects({ organizationId: orgId || currentOrganization.id })
  //   ).then(async (res) => {
  //     if (!res.error) {
  //       const newUniqueEmails = {
  //         ...currentUniqueEmails,
  //       };
  //       const projectsArray = res.payload;
  //       const mappedProjects = projectsArray.map((projectInfo) => ({
  //         title: projectInfo.title,
  //         id: projectInfo.id,
  //         roles: [],
  //       }));
  //       let mappedProjectsWithRoles = [...mappedProjects];
  //       for (let i = 0; i < mappedProjects.length; i++) {
  //         const projectRoles = await dispatch(
  //           fetchProjectUsers(mappedProjects[i].id)
  //         );
  //         if (!projectRoles.error) {
  //           const rolesArray = projectRoles.payload;
  //           mappedProjectsWithRoles[i].roles = rolesArray.filter(
  //             (role) => !newUniqueEmails[role.email]
  //           );
  //           for (let i = 0; i < rolesArray.length; i++) {
  //             if (newUniqueEmails[rolesArray[i].email]) {
  //               newUniqueEmails[rolesArray[i].email] =
  //                 newUniqueEmails[rolesArray[i].email] + 1;
  //             } else {
  //               newUniqueEmails[rolesArray[i].email] = 1;
  //             }
  //           }
  //           setUniqueEmails(newUniqueEmails);
  //         }
  //       }
  //       const newProjectRolesLevels = [...currentProjectsRolesLevels];
  //       newProjectRolesLevels[1] = mappedProjectsWithRoles;
  //       setProjectRolesLevels(newProjectRolesLevels);
  //       getNextProjectLevel(newProjectRolesLevels, 2, newUniqueEmails);
  //     }
  //   });
  // };

  // const getNextProjectLevel = async (
  //   currentProjectsRolesLevels,
  //   projectLevelIndex,
  //   currentUniqueEmails
  // ) => {
  //   const lastProjectLevel =
  //     currentProjectsRolesLevels[currentProjectsRolesLevels.length - 1];
  //   let result = [];
  //   const newUniqueEmails = {
  //     ...currentUniqueEmails,
  //   };
  //   for (let i = 0; i < lastProjectLevel.length; i++) {
  //     const subprojectsArray = await dispatch(
  //       fetchSubprojectsForProject({
  //         projectId: lastProjectLevel[i].id,
  //       })
  //     );
  //     if (!subprojectsArray.error) {
  //       const mappedSubprojects = subprojectsArray.payload.map(
  //         (subprojectInfo) => ({
  //           title: subprojectInfo.title,
  //           id: subprojectInfo.id,
  //           roles: [],
  //           parentId: lastProjectLevel[i].id,
  //         })
  //       );
  //       let mappedSubprojectsWithRoles = [...mappedSubprojects];
  //       for (let k = 0; k < mappedSubprojects.length; k++) {
  //         const projectRoles = await dispatch(
  //           fetchProjectUsers(mappedSubprojects[k].id)
  //         );
  //         if (!projectRoles.error) {
  //           const rolesArray = projectRoles.payload;
  //           mappedSubprojectsWithRoles[k].roles = rolesArray.filter(
  //             (role) => !newUniqueEmails[role.email]
  //           );
  //           for (let i = 0; i < rolesArray.length; i++) {
  //             if (newUniqueEmails[rolesArray[i].email]) {
  //               newUniqueEmails[rolesArray[i].email] =
  //                 newUniqueEmails[rolesArray[i].email] + 1;
  //             } else {
  //               newUniqueEmails[rolesArray[i].email] = 1;
  //             }
  //           }
  //           setUniqueEmails(newUniqueEmails);
  //         }
  //       }
  //       result = [...result, ...mappedSubprojects];
  //     }
  //   }
  //   if (result.length) {
  //     const newProjectRolesLevels = [...currentProjectsRolesLevels];
  //     newProjectRolesLevels[projectLevelIndex] = result;
  //     setProjectRolesLevels(newProjectRolesLevels);
  //     getNextProjectLevel(
  //       newProjectRolesLevels,
  //       projectLevelIndex + 1,
  //       newUniqueEmails
  //     );
  //   } else {
  //     setWorkspaceLoading(false);
  //   }
  // };

  const handleDotsClick = (event, member) => {
    event.stopPropagation();
    const rect = event.currentTarget.getBoundingClientRect();
    setMenuAnchor({
      userId: member.user.id,
      left: rect.right + window.scrollX - 5,
      top: rect.bottom + window.scrollY - 26,
    });
    setMenuUser(member);
  };

  const handleDelete = (userId) => {
    setMenuAnchor(null);
    if (
      confirm(
        "Вы действительно хотите удалить пользователя из рабочего пространства?"
      )
    ) {
      dispatch(
        deleteUserFromOrganization({
          organizationId: currentOrganization.id,
          userId,
        })
      ).then((res) => {
        if (!res.error) {
          updateUsersArray();
        }
      });
    }
  };

  const renderUserInfo = (member, isOwner) => {
    if (!member) return null;
    // const myRole =
    //   user &&
    //   user.projectRoles &&
    //   user.projectRoles.find(
    //     (role) =>
    //       role.projectId === projectInfo.projectId ||
    //       role.projectId === projectInfo.id
    //   );
    const amIOwner =
      user &&
      user.organizationRoles &&
      !!user.organizationRoles.find(
        (org) => org.organizationId === currentOrganization.id
      ) &&
      member.userId === user.userId;

    return (
      <div
        key={member.userId || member.user.email}
        style={modalStyles.memberRow}
      >
        <span style={modalStyles.email}>{member.user.email}</span>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <span style={modalStyles.select}>
            {amIOwner ? "Владелец" : userRoles[member.role]}
            {/* {`${myRole && myRole.id == member.id ? " (это вы)" : ""}`} */}
          </span>
          {(isOwner && user.userId !== member.user.id && (
            <button
              className="user-list-dots-btn"
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                borderRadius: "50%",
                marginLeft: 5,
                width: 28,
                height: 28,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "background 0.2s",
              }}
              onClick={(e) => handleDotsClick(e, member)}
              aria-label="More actions"
            >
              <img
                src={verticalDots}
                alt="menu"
                style={{ width: 18, height: 18 }}
              />
            </button>
          )) || <div style={{ width: 12, height: 28 }} />}
        </div>
        {!member.isToInvite &&
          menuAnchor &&
          menuAnchor.userId === member.user.id && (
            <div
              className="user-context-menu"
              style={{
                position: "fixed",
                top: menuAnchor.top,
                left: menuAnchor.left,
                zIndex: 9999,
                boxShadow: "0 4px 16px rgba(17,20,23,0.18)",
                background: "#262b36",
                borderRadius: 10,
                padding: "8px 0",
                minWidth: 110,
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
              }}
              ref={contextMenuRef}
            >
              <button
                style={{
                  background: "none",
                  border: "none",
                  color: "#FF4D4F",
                  fontWeight: 500,
                  fontSize: 15,
                  padding: "5px 5px",
                  display: "flex",
                  paddingLeft: 20,
                  alignItems: "center",
                  textAlign: "left",
                  justifyContent: "flex-start",
                  textAlign: "left",
                  cursor: "pointer",
                  borderRadius: 8,
                  transition: "background 0.1s",
                }}
                onClick={() => handleDelete(menuAnchor.userId)}
              >
                {t("mainScreen.upload.delete") || "Удалить"}
              </button>
            </div>
          )}
      </div>
    );
  };

  const handleRemoveUserRole = (role, projectInfo) => {
    if (projectInfo.isOrg) {
      if (
        confirm(
          `Вы действительно хотите удалить доступ пользователя к рабочему пространству ${projectInfo.title}?`
        )
      ) {
        const org = orgsList.find((item) => item.title === activeTab);
        dispatch(
          deleteUserFromOrganization({
            organizationId: org.id,
            userId: role.id,
          })
        ).then((res) => {
          if (!res.error) {
            updateUsersArray(org.id);
          }
        });
      }
      return;
    }

    if (
      confirm(
        `Вы действительно хотите удалить доступ пользователя к папке "${projectInfo.title}"?`
      )
    ) {
      const org = orgsList.find((item) => item.title === activeTab);
      dispatch(
        removeUserFromProject({
          projectId: projectInfo.id,
          userId: role.userId,
        })
      ).then((res) => {
        if (!res.error) {
          updateUsersArray(org.id);
        }
      });
    }
  };

  const onClickUser = (e, role) => {
    e.stopPropagation();

    const rect = e.currentTarget.getBoundingClientRect();
    setContextMenuPosition({
      top: rect.bottom + window.scrollY,
      left: rect.right + window.scrollX - 140,
    });
    setActiveRole(activeRole === role.userId ? null : role.userId || role.id);
  };

  if (!user) return null;

  const renderExplorerItem = (
    explorerItem,
    activePadding = 12,
    isLastChild
  ) => {
    const isOrganization = !!explorerItem.isOrg;
    const isVersion = !explorerItem.isFolder;
    const isSubfolder = !explorerItem.isRoot && !isVersion;

    const isCurrentFolder = false;

    const isCurrentProject = false;

    const isCurrentPath = false;

    const isCurrentRoot = explorerItem.isRoot && isCurrentPath;
    const isHovered = false;
    // const isHovered = hoveredItemId === explorerItem.id;

    return (
      <>
        <div
          key={explorerItem.id}
          className="projectExplorer-project-item"
          onClick={() => {
            if (explorerItem.isFolder || explorerItem.isVersion) {
              setUsersPopupEntity(explorerItem);
            }
            if (explorerItem.isOrg) {
              setOrgToShowUsersPopup(explorerItem);
            }
            // if (isOrganization) {
            //   onPressOrganization(explorerItem.id);
            //   return;
            // }
            // if (isCurrentProject) {
            //   dispatch(
            //     switchProjectUnfold(
            //       explorerItem.id,
            //       !explorerItem.isUnfolded,
            //       (currentProject && currentProject.path) || ""
            //     )
            //   );
            //   return;
            // }
            // if (isVersion) {
            //   navigate(`/video/${explorerItem.id}`);
            // } else {
            //   navigate(`/projects/${explorerItem.id}`, {
            //     state: {
            //       isFromPage: true,
            //     },
            //   });
            // }
          }}
          // onMouseEnter={() =>
          //   !showProjectContextMenu &&
          //   !showVersionContextMenu &&
          //   !selectedItem &&
          //   !isMobile &&
          //   setHoveredItemId(explorerItem.id)
          // }
          // onMouseLeave={() =>
          //   !showProjectContextMenu &&
          //   !showVersionContextMenu &&
          //   !selectedItem &&
          //   !isMobile &&
          //   setHoveredItemId(null)
          // }
          style={{
            cursor: "pointer",
            paddingLeft: activePadding,
            position: "relative",
            marginBottom: isOrganization || isLastChild ? 0 : isVersion ? 2 : 4,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 6,
              height: 6,
              position: "absolute",
              left: -8 + activePadding,
            }}
          >
            {isOrganization && (
              <StarIcon
                style={{
                  transform: "scale(3.7)",
                  fill: isHovered ? "#5CB1F6" : "#427FFF",
                }}
                width={24}
                height={24}
              />
            )}
            {!isVersion && !isOrganization && (
              <img
                src={arrowDown}
                alt="arrow"
                style={{
                  width: 6,
                  height: 6,
                  transform: !explorerItem.isUnfolded
                    ? "rotate(-90deg)"
                    : "rotate(0deg)",
                }}
              />
            )}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginLeft: isVersion ? 8 : 5,
            }}
          >
            {!isOrganization && (
              <img
                src={
                  isSubfolder
                    ? subfolderIcon
                    : isVersion
                      ? versionIcon
                      : subfolderIcon
                }
                alt="arrow"
                style={
                  isVersion
                    ? {
                        width: 18,
                        height: 18,
                      }
                    : {
                        width: 24,
                        height: 24,
                      }
                }
              />
            )}
          </div>
          <div
            style={{
              maxWidth: isHovered ? "75%" : "85%",
              display: "flex",
              alignItems: "center",
            }}
          >
            {isOrganization ? (
              <span
                className="projectExplorer-project-item-title"
                style={{
                  backgroundImage: isHovered
                    ? "linear-gradient(#5CB1F6)"
                    : "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)",
                  webkitBackgroundClip: "text",
                  color: "transparent",
                  // color: isHovered
                  //   ? "red"
                  //   : //: "linear-gradient(236.88deg, #3496FF 19.97%, #427FFF 76.98%)"
                  //     "blue",
                  fontSize: isOrganization ? 15 : 14,
                  fontWeight: isOrganization ? 600 : 500,
                  transition: "margin-right 0.1s ease",
                  maxWidth: "100%",
                  textOverflow: "ellipsis",
                  marginLeft: isVersion ? 7 : 3,
                }}
              >
                {explorerItem.title}
              </span>
            ) : (
              <span
                className="projectExplorer-project-item-title"
                style={{
                  color: isVersion
                    ? "C1C7D4"
                    : isCurrentFolder
                      ? "#F1F7FF"
                      : "#C1C7D4",
                  fontSize: isOrganization ? 15 : 14,
                  fontWeight: isOrganization ? 600 : 500,
                  transition: "margin-right 0.1s ease",
                  maxWidth: "100%",
                  textOverflow: "ellipsis",
                  marginLeft: isVersion ? 7 : 3,
                }}
              >
                {explorerItem.title || explorerItem.version}
              </span>
            )}
            {explorerItem.users &&
              explorerItem.users.map((user) => (
                <div
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  style={{
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    paddingRight: 5,
                    marginLeft: 10,
                    border: "1px solid #717B8E",
                    borderRadius: 5,
                    fontSize: 10,
                    whiteSpace: "nowrap",
                  }}
                >
                  {user.email}
                </div>
              ))}
            {/* {isOrganization &&
            organizationsTariffes[explorerItem.id] &&
            organizationsTariffes[explorerItem.id].plan &&
            organizationsTariffes[explorerItem.id].status === "ACTIVE" ? (
              <div
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/pricing");
                }}
                style={{
                  paddingTop: 2,
                  paddingBottom: 2,
                  paddingLeft: 5,
                  paddingRight: 5,
                  marginLeft: 10,
                  border: "1px solid #717B8E",
                  borderRadius: 5,
                  fontSize: 10,
                  whiteSpace: "nowrap",
                }}
              >
                {organizationsTariffes[explorerItem.id].plan.name}
              </div>
            ) : null} */}
          </div>
          {/* {isHovered && (explorerItem.isOrg || !!explorerItem.myRole) && ( */}
          {isHovered && (
            <div
              onMouseEnter={() =>
                !showProjectContextMenu &&
                !showVersionContextMenu &&
                !selectedItem &&
                setHoveredDotsItemId(explorerItem.id)
              }
              onMouseLeave={() =>
                !showProjectContextMenu &&
                !showVersionContextMenu &&
                !selectedItem &&
                setHoveredDotsItemId(null)
              }
              ref={dotsRef}
              onClick={(e) => onClickExplorerDots(explorerItem, e)}
              style={{
                position: "absolute",
                right: "8px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                padding: "4px",
              }}
            >
              <VerticalDots
                style={{
                  color:
                    selectedItem && selectedItem.id === explorerItem.id
                      ? "#3496FF"
                      : hoveredDotsItemId === explorerItem.id
                        ? "#C1C7D4"
                        : "#717B8E",
                }}
                width={16}
                height={16}
              />
            </div>
          )}
        </div>
        {(explorerItem.children &&
          Object.keys(explorerItem.children).length !== 0 &&
          Object.values(explorerItem.children).map((child, index) =>
            renderExplorerItem(
              child,
              activePadding + 17,
              index === Object.values(explorerItem.children).length - 1
            )
          )) ||
          null}
      </>
    );
  };

  return (
    <div
      className={isMobile ? "App-mobile" : "App"}
      style={{ overflowY: "scroll" }}
    >
      {/* HEADER */}
      <div
        className={isMobile ? "mainScreenHeader-mobile" : "mainScreenHeader"}
      >
        <div className={isMobile ? "header-left-mobile" : "header-left"}>
          {isMobile && (
            <div
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={{ display: "flex", marginTop: 7 }}
            >
              <MenuIcon color="white" />
            </div>
          )}
          <div
            onClick={() => navigate("/home", { replace: true })}
            className={"mainScreen-logoBlock"}
            style={{ cursor: "pointer" }}
          >
            <img src={AppLogo} style={{ height: "100%" }} alt="logo" />
          </div>
        </div>
        <div className="header-actions">
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      {/* LAYOUT: sidebar + main content */}
      <div
        className="teamScreen-container"
        style={{ alignItems: "flex-start" }}
      >
        {/* SIDEBAR */}
        {((!isMobile || isMenuOpen) && <ProfileSidebar activeTab="team" />) ||
          null}
        {/* MAIN CONTENT */}
        <main
          className={isMobile ? "teamScreen-main-mobile" : "teamScreen-main"}
        >
          <h1 className="teamScreen-title">Доступы в рабочих пространствах</h1>

          {usersArray.map((member, index) => {
            return renderUserInfo(member, !!currentOrganizationOwner);
          })}
          <Tabs
            variant="scrollable"
            value={activeTab}
            style={{
              color: "white",
              // marginTop: 10,
              marginBottom: 20,
              paddingLeft: 0,
              width: isMobile ? "100%" : "auto",
            }}
            onChange={(e, newValue) => {
              setActiveTab(newValue);
            }}
            aria-label="basic tabs example"
          >
            {filteredOrgsList &&
              filteredOrgsList.map((org) => (
                <Tab
                  icon={
                    <OrbitProgress
                      color={
                        activeTab === org.title && isLoading
                          ? "#cfb8ff"
                          : "transparent"
                      }
                      style={{
                        fontSize: 4,
                        marginLeft: 5,
                        marginTop: 0,
                        marginBottom: 0,
                      }}
                    />
                  }
                  iconPosition="end"
                  style={{
                    color: "white",
                    fontFamily: "NT Somic",
                    fontWeight: 400,
                    paddingBottom: 0,
                  }}
                  label={org.title}
                  value={org.title}
                />
              ))}
          </Tabs>
          {/* <div style={modalStyles.inviteRow}>
            <div style={modalStyles.inviteInputWrap}>
              <input
                type="email"
                value={newMemberEmail}
                onChange={handleEmailChange}
                placeholder="Введите электронную почту"
                style={modalStyles.inviteInput}
              />
            </div>
            <button
              style={
                isEmailValid
                  ? modalStyles.inviteBtn
                  : modalStyles.inviteBtnDisabled
              }
              onClick={() => {
                if (isEmailValid && !isLoading) {
                  handleInviteUser();
                }
              }}
              disabled={!isEmailValid}
            >
              {isLoading ? "Загрузка..." : "Пригласить"}
            </button>
          </div> */}
          {/* <div
            className="teamScreen-roles-block"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "stretch",
              width: "100%",
              minHeight: 400,
              overflow: "scroll",
              flex: "1 0 auto",
              height: 10,
            }}
          >
            {projectRolesLevels.map((projectLevel, index) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: 200,
                  height: "auto",
                  paddingLeft: index === 0 ? 0 : 15,
                  paddingRight: 15,
                  borderRight:
                    index === projectRolesLevels.length - 1
                      ? "none"
                      : "1px solid #c1c7d4",
                }}
              >
                {projectLevel.map((projectInfo, projectIndex) => (
                  <>
                    <span
                      className="teamScreen-text-item-title"
                      style={{
                        cursor: "default",
                        opacity: projectInfo.roles.length ? 1 : 0.5,
                        marginBottom: projectInfo.roles.length ? 4 : 0,
                        marginTop: projectIndex === 0 ? 0 : 16,
                      }}
                    >
                      {projectInfo.title}
                    </span>
                    {projectInfo.roles.map((role) => (
                      <div onClick={(e) => onClickUser(e, role)}>
                        <span
                          className={
                            role.email === user.email
                              ? "teamScreen-text-item-myself"
                              : "teamScreen-text-item"
                          }
                        >
                          {role.email}
                        </span>
                        {(!!activeRole && activeRole === role.userId) ||
                          (!!activeRole && activeRole === role.id && (
                            <UserRoleContextMenu
                              onRemove={() =>
                                handleRemoveUserRole(role, projectInfo)
                              }
                              onEditUserRole={() => {
                                setAccessPopupUser(role);
                              }}
                              isOpen={activeRole === role.userId}
                              onClose={() => setActiveRole(null)}
                              contextMenuPosition={contextMenuPosition}
                            />
                          ))}
                      </div>
                    ))}
                  </>
                ))}
              </div>
            ))}
          </div> */}
          <div className="teamScreen-projects-tree">
            {!workspaceLoading && !isLoading ? (
              Object.values(projectsStructure).map((explorerItem) =>
                renderExplorerItem(explorerItem)
              )
            ) : (
              <OrbitProgress style={{ fontSize: 8 }} color="white" />
            )}
          </div>
          <AccessPopup
            isOpen={!!accessPopupUser}
            editedUser={accessPopupUser}
            onSave={() => {
              const org = orgsList.find((item) => item.title === activeTab);
              updateUsersArray(org.id);
            }}
            onClose={() => setAccessPopupUser(null)}
          />
          {usersPopupEntity && (
            <UsersPopup
              isFromExplorer={true}
              usersLoading={false}
              projectInfo={usersPopupEntity}
              isOpen={usersPopupEntity}
              onClose={() => setUsersPopupEntity(null)}
              usersArray={[]}
              updateUsersArray={() => {}}
            />
          )}
          {orgToShowUsersPopup && (
            <OrgUsersPopup
              orgInfo={orgToShowUsersPopup}
              isOpen={orgToShowUsersPopup}
              onClose={() => setOrgToShowUsersPopup(null)}
            />
          )}
        </main>
      </div>
    </div>
  );
};

export default TeamScreen;
